// source: template.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var device_type_pb = require('./device_type_pb.js');
goog.object.extend(proto, device_type_pb);
goog.exportSymbol('proto.pb.Template', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Template = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.Template.repeatedFields_, null);
};
goog.inherits(proto.pb.Template, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Template.displayName = 'proto.pb.Template';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.Template.repeatedFields_ = [12,13,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Template.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Template.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Template} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Template.toObject = function(includeInstance, msg) {
  var f, obj = {
    templateid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    os: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    baseimage: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sourceimage: jspb.Message.getFieldWithDefault(msg, 6, ""),
    installimage: jspb.Message.getFieldWithDefault(msg, 7, ""),
    kickstart: jspb.Message.getFieldWithDefault(msg, 8, ""),
    buildscript: jspb.Message.getFieldWithDefault(msg, 9, ""),
    postinstall: jspb.Message.getFieldWithDefault(msg, 10, ""),
    depresolver: jspb.Message.getFieldWithDefault(msg, 11, ""),
    packagesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    ondemandpackagesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    optionalsvnfilesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    owner: jspb.Message.getFieldWithDefault(msg, 15, ""),
    modifiedby: jspb.Message.getFieldWithDefault(msg, 16, ""),
    lastmodified: jspb.Message.getFieldWithDefault(msg, 17, 0),
    approved: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    deleted: jspb.Message.getBooleanFieldWithDefault(msg, 19, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Template}
 */
proto.pb.Template.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Template;
  return proto.pb.Template.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Template} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Template}
 */
proto.pb.Template.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateid(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.DeviceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseimage(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceimage(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstallimage(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setKickstart(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuildscript(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostinstall(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepresolver(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addPackages(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addOndemandpackages(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addOptionalsvnfiles(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwner(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifiedby(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastmodified(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApproved(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Template.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Template.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Template} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Template.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplateid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBaseimage();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSourceimage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInstallimage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getKickstart();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBuildscript();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPostinstall();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDepresolver();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPackagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getOndemandpackagesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getOptionalsvnfilesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getOwner();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getModifiedby();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getLastmodified();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getApproved();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
};


/**
 * optional string TemplateID = 1;
 * @return {string}
 */
proto.pb.Template.prototype.getTemplateid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setTemplateid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceType Type = 2;
 * @return {!proto.pb.DeviceType}
 */
proto.pb.Template.prototype.getType = function() {
  return /** @type {!proto.pb.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.DeviceType} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string OS = 3;
 * @return {string}
 */
proto.pb.Template.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setOs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Description = 4;
 * @return {string}
 */
proto.pb.Template.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BaseImage = 5;
 * @return {string}
 */
proto.pb.Template.prototype.getBaseimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setBaseimage = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string SourceImage = 6;
 * @return {string}
 */
proto.pb.Template.prototype.getSourceimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setSourceimage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string InstallImage = 7;
 * @return {string}
 */
proto.pb.Template.prototype.getInstallimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setInstallimage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Kickstart = 8;
 * @return {string}
 */
proto.pb.Template.prototype.getKickstart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setKickstart = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string BuildScript = 9;
 * @return {string}
 */
proto.pb.Template.prototype.getBuildscript = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setBuildscript = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string PostInstall = 10;
 * @return {string}
 */
proto.pb.Template.prototype.getPostinstall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setPostinstall = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string DepResolver = 11;
 * @return {string}
 */
proto.pb.Template.prototype.getDepresolver = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setDepresolver = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated string Packages = 12;
 * @return {!Array<string>}
 */
proto.pb.Template.prototype.getPackagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setPackagesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.addPackages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.clearPackagesList = function() {
  return this.setPackagesList([]);
};


/**
 * repeated string OnDemandPackages = 13;
 * @return {!Array<string>}
 */
proto.pb.Template.prototype.getOndemandpackagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setOndemandpackagesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.addOndemandpackages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.clearOndemandpackagesList = function() {
  return this.setOndemandpackagesList([]);
};


/**
 * repeated string OptionalSvnFiles = 14;
 * @return {!Array<string>}
 */
proto.pb.Template.prototype.getOptionalsvnfilesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setOptionalsvnfilesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.addOptionalsvnfiles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.clearOptionalsvnfilesList = function() {
  return this.setOptionalsvnfilesList([]);
};


/**
 * optional string Owner = 15;
 * @return {string}
 */
proto.pb.Template.prototype.getOwner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setOwner = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string ModifiedBy = 16;
 * @return {string}
 */
proto.pb.Template.prototype.getModifiedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setModifiedby = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 LastModified = 17;
 * @return {number}
 */
proto.pb.Template.prototype.getLastmodified = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setLastmodified = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional bool Approved = 18;
 * @return {boolean}
 */
proto.pb.Template.prototype.getApproved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setApproved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool Deleted = 19;
 * @return {boolean}
 */
proto.pb.Template.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Template} returns this
 */
proto.pb.Template.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


goog.object.extend(exports, proto.pb);
